// client_token(JWT) 디코드 단일 진입점.
// store/라우터 가드/회사 판별 유틸이 각자 jwtDecode 를 호출하지 않도록 한 곳으로 모은다.
// store 를 import 하지 않는다(순환 참조 방지: store → api/loginAPI → utils/demoCompany → 이 파일).
import VueCookies from 'vue-cookies'
import { jwtDecode } from 'jwt-decode'

// client_token 페이로드를 동기적으로 반환한다. 토큰이 없거나 디코드에 실패하면 null.
// 쿠키는 동기 조회가 가능하므로, 라우터 가드(beforeEach)처럼 store 하이드레이션 이전 시점에서도 쓸 수 있다.
export const decodeClientToken = () => {
  const clientToken = VueCookies.get('client_token')
  if (!clientToken) {
    return null
  }
  try {
    return jwtDecode(clientToken)
  } catch (error) {
    console.error('Error decoding client_token:', error)
    return null
  }
}

// 서버가 서명한 company_code. 미로그인/디코드 실패 시 null 이므로 회사 판별은 성립하지 않는다(= 특정 회사로 오판하지 않음).
// 백엔드 EXKR 가드(ExkrGuard)도 동일하게 client_token 의 companyCode 클레임으로 회사를 격리하므로,
// 프론트 메뉴/라우트 노출과 백엔드 403 판정이 같은 값을 보게 된다.
export const getTokenCompanyCode = () => decodeClientToken()?.companyCode ?? null
